document.addEventListener('calendarRendered', () => {

    const calendar = $('.calendar');
    const currentYear = calendar.data('currentYear');
    const currentMonth = calendar.data('currentMonth');
    const firstMonthDay = new Date(currentYear, currentMonth, 1);
    const lastMonthDay = new Date(currentYear, currentMonth + 1, 0);

    const formatDate = (date) => {
        let year = date.getFullYear();
        let month = (date.getMonth() + 1).toString().padStart(2, '0');
        let day = date.getDate().toString().padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const getCurrencyChar = (currency) => {
        if(currency === 'PLN') return 'zł';
        if(currency === 'USD') return '$';
        if(currency === 'EUR') return '€';
        return '';
    }
    const getCalendarPrices = async () => {
        const params = {
            action: 'get-service-prices-summary',
            service_id: currentServiceId,
            date_from: formatDate(firstMonthDay),
            date_to: formatDate(lastMonthDay),
            lang: $('#tour_lang').val() || 'ANG'
        };

        const currentUrl = new URL(window.location.href);
        const ajaxUrl = `${currentUrl.origin}/wp-admin/admin-ajax.php`;
        const url = new URL(ajaxUrl);
        url.search = new URLSearchParams(params).toString();

        try {
            const response = await fetch(url);
            if (!response.ok)
            {
                $('.calendar__day--priceBadge').remove();
                throw new Error('Error fetching calendar prices');
            }
            const data = await response.json();
            return data;
        } catch (error) {
            console.error('Error:', error);
        }
    };

    getCalendarPrices().then(r => {
        if (!r || !r.data) return;

        let prices = r.data;
        let privacyType = $('#private_or_group').val() === 'Private' ? 'Private' : 'Shared';
        let currency = currentCurrency ?? 'EUR';

        $('.calendar__day').each((i, el) => {
            const day = $(el).data('day-number');
            const dayDate = formatDate(new Date(currentYear, currentMonth, day));

            if(!prices[privacyType][dayDate]) return
            const price = prices[privacyType][dayDate][currency] || 'N/A';

            $(el).find('.calendar__day--priceBadge').text(price+' '+getCurrencyChar(currency));
        });
    });
});
